import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { JSString } from 'kts-scaffold-framework/utils/kit';
import { AppType, AppSystemType } from 'kts-platform-frame/entry/constant';
import ReduxState, { IConfigApp } from 'kts-platform-frame/redux/ReduxState';
import { connect } from 'kts-platform-frame/redux';
import { IAppInfo } from 'kts-platform-frame/dataModel';
import { withRouter } from 'kts-platform-frame/routes';
import { NodeEnvType } from 'kts-platform-frame/entry/constant';
import { appIndexUri } from 'kts-platform-frame/entry/configUtils';
import AppSdk from 'kts-platform-frame/appSdk';
import { appStore } from 'kts-platform-frame/api';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import UIAppError from './UI.AppError';
import UIAppLoading from './UI.AppLoading';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    appMap?: Map<string, IConfigApp>;
    NODE_ENV?: NodeEnvType;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** iframe UI 模块状态 */
export class UIIframeModulesState {
    /** 是否加载App数据中 */
    isloadingAppInfo: boolean = true;

    /** iframe 是否加载完成  */
    isLoad: boolean = false;

    /** app数据 */
    appInfo: IAppInfo = null;
}

/** iframe */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    appMap: state.config.appList.map,
    NODE_ENV: state.env.NODE_ENV,
}))
export default class UIIframe extends UIBasic<IProps, ModulesState> {

    /** 当前的appKey */
    private currentAppKey: string;

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentDidMount() {
        AppSdk.instance.initialization();
        this.updateAppInfo();
    }

    componentDidUpdate() {
        this.updateAppInfo();
    }

    render() {
        const search = window.location.search;
        if (this.appKey === 'debugging') {
            return (
                <div className={css.iframe} >
                    <iframe id="worbench" src={`http://debugging.dev.kingxunlian.com${search}`} />;
                </div>
            );
        } else if(this.appKey === 'error'){
            return <UIAppError />;
        } else {
            const hash = window.location.hash || '';
            const url = this.appIndexUri();
            return (
                <div key={url} className={css.iframe} >
                    {(this.myModulesStat.isloadingAppInfo || !this.myModulesStat.isLoad) && <UIAppLoading />}
                    {
                        !this.myModulesStat.isloadingAppInfo
                        && (
                            url
                                ? <span>
                                    <iframe 
                                        id="worbench"
                                        style={this.iframeStyle}
                                        onLoad={this.onLoadIframeHandler}
                                        src={`${url}${hash.replace('#', '/')}${search}`}
                                    />
                                </span>
                                : <UIAppError /> 
                        )
                    }
                </div>
            );
        }
    }

    /** iframe 的样式 */
    private get iframeStyle() {
        if (this.myModulesStat.isLoad) {
            return null;
        } else {
            return { display: 'none' };
        }
    }

    /** 当前组件模块数据节点 */
    private get myModulesStat(): UIIframeModulesState {
        return this.modulesState.uiIframeModulesState;
    }

    /** APP的启动地址 */
    private appIndexUri(): string {

        // APP 化代码
        const appInfo: IAppInfo = this.myModulesStat.appInfo;
        if (!appInfo) {
            return null;
        }

        switch (appInfo.appType) {
            // 三条腿应用
            case AppType.legged3:
                return this.getLegged3AppUrl(appInfo);

            // 系统应用
            case AppType.system:
                return this.getSystemAppUrl(appInfo);

            // APP类型错误
            default:
                console.error('APP类型错误');
                return null;
        }
    }

    /** 获取 三条腿应用 的app url */
    private getLegged3AppUrl(appInfo: IAppInfo): string {
        return JSString.isUrl(appInfo.appIndexUri);
    }

    /** 获取 系统应用 的app url */
    private getSystemAppUrl(appInfo: IAppInfo): string {
        const app = this.props.appMap.get(appInfo.appKey);
        const hash = window.location.hash || '';
        if (!app) {
            return null;
        }

        switch (app.TYPE) {
            case AppSystemType.核心功能:
                this.props.history.push(app.URL);
                return null;

            case AppSystemType.潜入APP:
                const url = `${appIndexUri(appInfo.appKey)}${hash.replace('#', '/')}`;
                return url;

            default:
                console.error('app类型错误');
                return null;
        }
    }

    /** 启动的appKey */
    private get appKey(): string {
        return this.props.match.params.appKey;
    }

    /** 设置appInfo数据 */
    private updateAppInfo = async (): Promise<void> => {

        if (this.currentAppKey === this.appKey || this.appKey === 'error') {
            return;
        }

        const appKey = this.appKey;
        this.currentAppKey = appKey;
        this.myModulesStat.isLoad = false;

        // 是否传递了APP数据
        const state = this.props.location.state as any;
        if (state && state.appInfo) {
            this.myModulesStat.appInfo = state.appInfo;
            this.myModulesStat.isloadingAppInfo = false;
        } else {
            this.myModulesStat.isloadingAppInfo = true;
            const queryAppInfo = await appStore.queryAppInfo(this, { appKey });
            this.myModulesStat.isloadingAppInfo = false;
            if (queryAppInfo.er) {
                this.myModulesStat.appInfo = null;
                this.setModulesState();
                return null;
            }
            this.myModulesStat.appInfo = queryAppInfo.res;
        }
        this.setModulesState();
    }

    /** Iframe 加载完成 */
    private onLoadIframeHandler = () => {
        this.myModulesStat.isLoad = true;
        this.setModulesState();
    }
}



// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench/UI.Iframe.tsx